/**
 * 用户管理模块路由
 * 对应菜单：用户管理
 */

export default [
  // 用户列表
  {
    path: 'admin/users',
    name: 'UserList',
    component: () =>
      import(/* webpackChunkName: "users-list" */ '@/views/users/UserListView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'user-list',
      title: '用户管理'
    }
  },
  // 用户详情
  {
    path: 'admin/users/detail',
    name: 'UserDetail',
    component: () =>
      import(/* webpackChunkName: "users-detail" */ '@/views/users/UserDetailView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'user-detail',
      title: '用户详情',
      hidden: true
    }
  }
]
